import React, { useEffect, useState } from "react";
import SideBarBack from "../../components/SidebarBack";
import { useDispatch } from "react-redux";
import { setDrawerActiveMenu } from "../../store/features/webUtilitiesSlice";
import Accordion from "react-bootstrap/Accordion";
// import "bootstrap/dist/css/bootstrap.min.css";
import search from "../../assets/images/faq/search.png";
import { GET_GENERAL_PAGES } from "../../config/ApisCollection";
import axios from "axios";

export default function Menu() {
  const dispatch = useDispatch();
  const [generalData, setGeneralData] = useState(null);
  const [activeTab, setActiveTab] = useState(0);

  const handleCloseDrawer = async () => {
    await dispatch(setDrawerActiveMenu(34));
  };

  const GetGeneralPages = async () => {
    const get_header = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    await axios
      .post(GET_GENERAL_PAGES, { country: "us" }, get_header)
      .then((response) => {
        setGeneralData(response.data);
      });
  };

  useEffect(() => {
    GetGeneralPages();
  }, []);
  console.log();

  return (
    <div className="w-full h-full relatsive">
      <div className="w-full flex mb-2">
        <SideBarBack handleCloseDrawer={handleCloseDrawer} />
      </div>
      <div className="flex flex-col text-left gap-2 mt-6 w-full mx-auto pb-14">
        {/* <div className="flex gap-2 items-center mb-3">
          <img src={search} className="w-3.5 h-3.5" />
          <input
            type="email"
            name="email"
            value={""}
            onChange={() => {}}
            placeholder="Search ..."
            className="w-full sm:text-base border-none sm:px-2 sm:py-2 py-2 px-2 text-xs rounded-xl focus:outline-none focus:border-none"
          />
        </div> */}
        {generalData !== null ? (
          <Accordion defaultActiveKey="352" className="border-none">
            {generalData &&
              generalData[8].faqlist?.map((option, index) => (
                <Accordion.Item
                  key={index}
                  className={`border-b border-[#ddd] py-3 px-2 ${
                    activeTab === index ? "bg-[#ffede0] " : "bg-[#fef8f4] "
                  }`}
                  eventKey={index}
                  onClick={() => {
                    setActiveTab(index);
                  }}
                >
                  <Accordion.Header>
                    <div className="!text-sm font-medium text-left mt-4">
                      <div className="block justify-between w-full">
                        <span>Q.{index + 1}.)</span> <span>{option.q}</span>{" "}
                      </div>
                    </div>
                  </Accordion.Header>
                  {activeTab === index && (
                    <Accordion.Body className="!border-none">
                      {/* <p className="!text-xs font-medium">{option.a}</p> */}
                      <div
                        className="!text-xs font-normal text-[#222] mt-2"
                        dangerouslySetInnerHTML={{
                          __html: option.a,
                        }}
                      ></div>
                    </Accordion.Body>
                  )}
                </Accordion.Item>
              ))}
          </Accordion>
        ) : generalData === null ? (
          <div className="flex justify-center">Loading...</div>
        ) : (
          <div className="flex justify-center">Loading...</div>
        )}
      </div>
    </div>
  );
}
